var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHours = function SvgHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F22",
    d: "M14 .667C21.364.667 27.333 6.636 27.333 14S21.363 27.333 14 27.333.667 21.364.667 14 6.636.667 14 .667M14 6a1.333 1.333 0 0 0-1.334 1.333V14c0 .354.141.693.391.943l4 4a1.333 1.333 0 0 0 1.886-1.886l-3.61-3.609V7.333A1.333 1.333 0 0 0 14 6"
  })));
};
export default SvgHours;